import React, { useState, useEffect } from "react";
import "./HomeOne.css";
import Abelha from "../../assets/abelha.png";
import LoadingIndicator from "../LoadingIndicator/LoadingIndicator"; // ajuste o caminho conforme sua estrutura

const HomeOne = () => {
  const [isLoading, setIsLoading] = useState(true);

  // Simula um carregamento (ex: dados da API ou imagens)
  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 2000); // 2 segundos de carregamento
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <>
      {/* Seção Hero com background em imagem */}
      <section className="home-one" aria-label="Seção principal do site">
        <div className="home-one-container">
          <div className="home-one-content">
            <h1 className="section-title">
              Descubra o Sabor da Natureza<span>.</span>
            </h1>
            <h2 className="section-subtitle">
              Descubra o sabor autêntico do mel artesanal, produzido com amor e respeito à natureza
            </h2>
            <button
              className="ver-mais-button"
              onClick={() => {
                const produtosSection = document.getElementById("produtos");
                if (produtosSection)
                  produtosSection.scrollIntoView({ behavior: "smooth" });
              }}
            >
              NOSSOS PRODUTOS
            </button>
          </div>
        </div>
        {/* Indicador: abelha posicionada no final do background */}
        <img
          src={Abelha}
          alt="Veja mais conteúdo"
          className="bee-scroll"
          onClick={() => {
            const produtosSection = document.getElementById("produtos");
            if (produtosSection)
              produtosSection.scrollIntoView({ behavior: "smooth" });
          }}
        />
      </section>

      {/* Seção de Diferenciais com 3 cards (ainda não implementada) */}
    </>
  );
};

export default HomeOne;
